import { render, staticRenderFns } from "./CuponAmigo.vue?vue&type=template&id=6861b6f0&scoped=true&"
import script from "./CuponAmigo.vue?vue&type=script&lang=js&"
export * from "./CuponAmigo.vue?vue&type=script&lang=js&"
import style0 from "./CuponAmigo.vue?vue&type=style&index=0&id=6861b6f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6861b6f0",
  null
  
)

export default component.exports